// extracted by mini-css-extract-plugin
export var container = "_nv-0";
export var dotAnimation = "_nv-2";
export var dotsLoading = "_nv-1";